import React from "react";

import logo from "../assets/logo.png";
import info1 from "../assets/info/zdj1.JPG";
import info2 from "../assets/info/zdj2.JPG";
import galleryHelper from "./gallery-helper.js";

const thirdImages = galleryHelper.getImagesNames(
  galleryHelper.importPhotos(
    require.context("../assets/info", false, /.*_th\.(JPG|png|jpe?g|svg)$/)
  )
);

const mainPl = `W roku szkolnym 2019/20 rozpoczęliśmy w naszej szkole realizację nowego projektu pod tytułem “English - just speak! - Szkoła bez granic”. Przedsięwzięcie w całości będzie finansowane ze środków unijnych w ramach programu Erasmus+. Projekt zakłada dwuletnią współpracę trzech szkół: z Polski, Niemiec i Chorwacji. Naszymi partnerami są Lise Meitner Gymnasium z Geldern oraz  Osnovna škola Frana Galovića z Zagrzebia.
Koordynatorem całego międzynarodowego partnerstwa w projekcie jest
Zespół Szkół w Babicy.
Celem projektu jest zmotywowanie uczniów do komunikacji w języku angielskim. Dzięki współpracy z zagranicznymi szkołami chcemy pokazać uczniom, iż język angielski jest więcej niż przedmiotem lekcyjnym, jest on narzędziem służącym do komunikacji dzięki któremu można zdobywać przyjaciół, uczyć się, rozwijać się a potem studiować i pracować za granicą. Aktywna komunikacja w języku angielskim wspomaga również rozbudzanie tolerancji, jest mechanizmem łączącym kultury, może przyczyniać się do walki z rasizmem i ksenofobią.`;
const mainEn = `In the school year of 2019/20, we have started a new project at our school called 'English - just speak! - School without borders'. The entire project will be financed from EU funds under the Erasmus+ program. The project involves a two-year cooperation of three schools: from Poland, Germany and Croatia. Our partners are Lise Meitner Gymnasium from Geldern and Osnovna škola Frana Galović from Zagreb.
The coordinator of the entire international partnership in the project is
the school in Babica, in Poland.
The goal of the project is to motivate students to communicate in English. Thanks to cooperation with foreign schools, we want to show students that English is more than a lesson, it is a communication tool that allows you to make friends, learn, develop and then study and work abroad. Active communication in English also supports the development of tolerance, is a mechanism connecting cultures, can contribute to the fight against racism and xenophobia.`;

const secondaryPl = `W październiku 2019 roku została zorganizowana wizyta przygotowawcza, w której wzięli udział przedstawiciele wszystkich szkół partnerskich.
Podczas spotkania ustalono terminy działań projektowych w Polsce, Chorwacji i Niemczech oraz szczegółowo omówiono zakres prac, włączając w to plan ewaluacji i upowszechniania. Na wniosek rodziców uczniów ze wszystkich szkół omówiono również kwestie dotyczące przyjmowania uczniów przez rodziny goszczące.`;

const datesPl = [
  `Terminy spotkań międzynarodowych:`,
  `Polska 02.02.2020 – 08.02.2020`,
  `Chorwacja 24.05.2020 – 30.05.2020`,
  `Niemcy 14.03.2021 – 20.03.2021`,
];

const secondaryEn = `In October 2019, the first meeting of the teachers was organized, representatives of all partner schools turned up.
The result of the meeting was arranging the dates for project activities in Poland, Croatia and Germany as well as a detailed schedule and scope of work, including an evaluation and dissemination plan. At the request of parents of students from all schools, the issues related to the admission of students by host families were also discussed.`;

const datesEn = [
  `The dates of international meetings:`,
  `Poland 02/02/2020 - 08/02/2020`,
  `Croatia 24/05/2020 - 30/05/2020`,
  `Germany 14/03/2021 - 20/03/2021`,
];

const thirdPl = `W dniach od 04.09.2021 do 07.09.2021 odbyło się spotkanie liderów wszystkich partnerów biorących udział w projekcie. Podczas spotkania omówiono dotychczasowe przedsięwzięcia projektowe i zaplanowano działania, które będą zrealizowane w roku szkolnym 2021/22.
Jeśli sytuacja pandemiczna pozwoli na spotkania uczniów, to odbędą się one w Chorwacji w listopadzie 2021 i w Niemczech w kwietniu 2022.`;

const ProjectInfoContext = React.createContext({
  info: {
    pl: mainPl,
    en: mainEn,
  },
  photos: [logo, info1, info2],
  second: {
    pl: {
      text: secondaryPl,
      dates: datesPl,
    },
    en: {
      text: secondaryEn,
      dates: datesEn,
    },
  },
  third: {
    pl: {
      text: thirdPl,
    },
    img: thirdImages,
  },
});

export default ProjectInfoContext;
